module.exports = __webpack_public_path__ + "static/media/SM-Slider_TrackBackground_idle.45fd58af.svg";